/**
 * Script simple para probar actualización de categorías
 */

// Exportar para que TypeScript considere esto un módulo
export {};

// Función para probar actualización directa
(window as any).testCategoryUpdate = async function(categoryName: string, enabled: boolean) {
  console.log(`🧪 Probando actualización de categoría "${categoryName}" a ${enabled ? 'habilitada' : 'deshabilitada'}...`);
  
  try {
    // Verificar Firebase
    if (!(window as any).auth) {
      console.log('❌ Firebase no disponible');
      return false;
    }
    
    // Importar servicio
    const { default: optimizedService } = await import('../services/optimizedInventoryService');
    
    // Obtener categorías
    const categories = await optimizedService.getCategories();
    console.log(`📊 Categorías disponibles: ${categories.length}`);
    
    // Buscar la categoría
    const category = categories.find(cat => cat.name === categoryName);
    if (!category) {
      console.log(`❌ Categoría "${categoryName}" no encontrada`);
      console.log('📋 Categorías disponibles:', categories.map(cat => cat.name));
      return false;
    }
    
    console.log(`✅ Categoría encontrada: ${category.name} (${category.id})`);
    console.log(`   Estado actual: ${category.enabled}`);
    
    // Actualizar categoría usando el nombre exacto
    console.log('🔄 Actualizando categoría...');
    await optimizedService.updateCategory(categoryName, { enabled });
    
    // Verificar cambio
    console.log('🔍 Verificando cambio...');
    const updatedCategories = await optimizedService.getCategories();
    const updatedCategory = updatedCategories.find(cat => cat.id === category.id);
    
    if (updatedCategory) {
      console.log(`✅ Categoría actualizada: ${updatedCategory.name}`);
      console.log(`   Nuevo estado: ${updatedCategory.enabled}`);
      console.log(`   Cambio exitoso: ${updatedCategory.enabled === enabled ? 'SÍ' : 'NO'}`);
      return updatedCategory.enabled === enabled;
    } else {
      console.log('❌ No se pudo verificar el cambio');
      return false;
    }
    
  } catch (error) {
    console.error('❌ Error en prueba:', error instanceof Error ? error.message : error);
    return false;
  }
};

// Función para probar todas las categorías
(window as any).testAllCategories = async function() {
  console.log('🧪 Probando todas las categorías...');
  
  try {
    const { default: optimizedService } = await import('../services/optimizedInventoryService');
    
    const categories = await optimizedService.getCategories();
    console.log(`📊 Total de categorías: ${categories.length}`);
    
    if (categories.length === 0) {
      console.log('⚠️ No hay categorías. Creando algunas de prueba...');
      await (window as any).createTestCategories();
      const newCategories = await optimizedService.getCategories();
      console.log(`📊 Nuevas categorías: ${newCategories.length}`);
    }
    
    const results = [];
    
    for (const category of categories) {
      console.log(`\n🔄 Probando "${category.name}"...`);
      
      // Probar habilitar
      const enableResult = await (window as any).testCategoryUpdate(category.name, true);
      results.push({ name: category.name, enable: enableResult });
      
      // Esperar un poco
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Probar deshabilitar
      const disableResult = await (window as any).testCategoryUpdate(category.name, false);
      results.push({ name: category.name, disable: disableResult });
      
      // Esperar un poco
      await new Promise(resolve => setTimeout(resolve, 500));
    }
    
    console.log('\n📊 Resultados:');
    results.forEach(result => {
      console.log(`   ${result.name}: ${result.enable ? '✅' : '❌'} habilitar, ${result.disable ? '✅' : '❌'} deshabilitar`);
    });
    
    return results;
    
  } catch (error) {
    console.error('❌ Error en prueba completa:', error);
    throw error;
  }
};

// Función para verificar estado actual
(window as any).checkCategoryStatus = async function() {
  console.log('🔍 Verificando estado actual de categorías...');
  
  try {
    const { default: optimizedService } = await import('../services/optimizedInventoryService');
    
    const categories = await optimizedService.getCategories();
    console.log(`📊 Total de categorías: ${categories.length}`);
    
    if (categories.length === 0) {
      console.log('⚠️ No hay categorías en la base de datos');
      return [];
    }
    
    console.log('\n📋 Estado de categorías:');
    categories.forEach((category, index) => {
      console.log(`   ${index + 1}. ${category.name} (${category.id})`);
      console.log(`      - enabled: ${category.enabled}`);
      console.log(`      - createdAt: ${category.createdAt}`);
    });
    
    return categories;
    
  } catch (error) {
    console.error('❌ Error verificando estado:', error);
    throw error;
  }
};

console.log('🧪 Scripts de prueba de categorías cargados:');
console.log('- window.testCategoryUpdate(name, enabled) - Probar actualización específica');
console.log('- window.testAllCategories() - Probar todas las categorías');
console.log('- window.checkCategoryStatus() - Verificar estado actual');
